// test1930
(1930 && 0);
